/* eslint-disable react/display-name */
import React, { useState, useImperativeHandle, forwardRef } from "react";

// Components

// Lib
import Drawer from "@mui/material/Drawer";
import { useNavigate, useParams } from "react-router-dom";
import SidebarMenu from "../Reusable/SidebarMenu";

interface StandardLayoutProps {
  children?: React.ReactNode;
  ref?: React.Ref<unknown>;
}

const StandardLayout = forwardRef<unknown, StandardLayoutProps>((props, ref) => {
  const { children } = props;
  const [isOpenSideMenu, handleToggleSideMenu] = useState(false);
  const history = useNavigate();
  const { ROUTE_ID } = useParams();

  useImperativeHandle(ref, () => ({
    handleToggleSideMenu: () => {
      handleToggleSideMenu(!isOpenSideMenu);
    },
  }));

  return (
    <div className="standardLayout">
      {/* SIDE BAR MENU */}
      {window.config.sideMenu && (
        <Drawer
          variant="temporary"
          anchor="right"
          open={isOpenSideMenu}
          onClose={() => handleToggleSideMenu(false)}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <SidebarMenu menuContent={window.config.sideMenu} history={history} pageName={ROUTE_ID} />
        </Drawer>
      )}

      {/* CONTENT */}
      <div className="children-wrapper">{children}</div>
    </div>
  );
});

export default StandardLayout;
